module.exports = __webpack_public_path__ + "549a899820725a21fa0e1cc943d58ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/images/dni-logo.jpg
// module id = 771
// module chunks = 0